import type { FeatureRequestStatus, FeatureRequestType, EffortEstimate } from '../types';

export const FEATURE_REQUEST_STATUS_LABELS: Record<FeatureRequestStatus, string> = {
  IN_DISCUSSION: 'În discuție',
  AWAITING_APPROVAL: 'Așteaptă aprobare',
  APPROVED: 'Aprobat',
  REJECTED: 'Respins',
  IN_PROGRESS: 'În lucru',
  IMPLEMENTED: 'Implementat',
  DUPLICATE: 'Duplicat',
};

/** Badge classes per status — tuned to the app's oklch palette. */
export const FEATURE_REQUEST_STATUS_STYLES: Record<FeatureRequestStatus, string> = {
  IN_DISCUSSION: 'bg-info/12 text-info border border-info/25',
  AWAITING_APPROVAL: 'bg-accent/14 text-accent-dark border border-accent/30',
  APPROVED: 'bg-success/14 text-success border border-success/30',
  REJECTED: 'bg-error/12 text-error border border-error/25',
  IN_PROGRESS: 'bg-primary/12 text-primary border border-primary/25',
  IMPLEMENTED: 'bg-success/18 text-success border border-success/35',
  DUPLICATE:
    'bg-[var(--surface-panel-strong)] text-[color:var(--ink-muted)] border border-[color:var(--surface-line-strong)]',
};

/** Small dot color per status (for the list + timeline). */
export const FEATURE_REQUEST_STATUS_DOT: Record<FeatureRequestStatus, string> = {
  IN_DISCUSSION: 'bg-info',
  AWAITING_APPROVAL: 'bg-accent',
  APPROVED: 'bg-success',
  REJECTED: 'bg-error',
  IN_PROGRESS: 'bg-primary',
  IMPLEMENTED: 'bg-success',
  DUPLICATE: 'bg-[color:var(--ink-soft)]',
};

export const FEATURE_REQUEST_TYPE_LABELS: Record<FeatureRequestType, string> = {
  FEATURE: 'Funcționalitate',
  CHANGE: 'Modificare',
  BUG: 'Bug',
};

export const FEATURE_REQUEST_TYPE_STYLES: Record<FeatureRequestType, string> = {
  FEATURE: 'bg-primary/10 text-primary',
  CHANGE: 'bg-accent/12 text-accent-dark',
  BUG: 'bg-error/10 text-error',
};

export const EFFORT_LABELS: Record<EffortEstimate, string> = {
  S: 'S · <1 zi',
  M: 'M · 1–4 zile',
  L: 'L · 1–2 săpt.',
  XL: 'XL · >2 săpt.',
};

export const EFFORT_STYLES: Record<EffortEstimate, string> = {
  S: 'bg-success/12 text-success',
  M: 'bg-info/12 text-info',
  L: 'bg-accent/14 text-accent-dark',
  XL: 'bg-error/12 text-error',
};

/** The ordered lifecycle, used for the progress timeline. */
export const FEATURE_REQUEST_LIFECYCLE: FeatureRequestStatus[] = [
  'IN_DISCUSSION',
  'AWAITING_APPROVAL',
  'APPROVED',
  'IN_PROGRESS',
  'IMPLEMENTED',
];
